import { Mark, mergeAttributes } from '@tiptap/core';

export const PS_HIGHLIGHT_TOKEN_ATTR = 'data-ps-highlight';

export const PsHighlightExtension = Mark.create({
  // Keep the name `highlight` so existing UI hooks (color highlight buttons)
  // continue to work without needing to change command names.
  name: 'highlight',

  addAttributes() {
    return {
      token: {
        default: null,
        parseHTML: (element) => {
          const explicit = element.getAttribute?.(PS_HIGHLIGHT_TOKEN_ATTR);
          if (explicit) return explicit;
          const classAttr = element.getAttribute?.('class') || '';
          const match = classAttr.match(/\bps-highlight--([a-z0-9-]+)\b/i);
          return match ? match[1] : null;
        },
        renderHTML: (attributes) => {
          if (!attributes.token) return {};
          return { [PS_HIGHLIGHT_TOKEN_ATTR]: attributes.token };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span',
        getAttrs: (element) => {
          const classAttr = element.getAttribute?.('class') || '';
          const tokenAttr = element.getAttribute?.(PS_HIGHLIGHT_TOKEN_ATTR);
          if (tokenAttr) return {};
          if (/\bps-highlight--[a-z0-9-]+\b/i.test(classAttr)) return {};
          return false;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const token = HTMLAttributes.token;
    const classes = ['ps-highlight'];
    if (token) classes.push(`ps-highlight--${token}`);
    const { token: _token, ...rest } = HTMLAttributes;
    return ['span', mergeAttributes(rest, { class: classes.join(' ') }), 0];
  },
});

export default PsHighlightExtension;

